"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_VALIDATION_REGEX = void 0;
const EMAIL_VALIDATION_REGEX = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i;
exports.EMAIL_VALIDATION_REGEX = EMAIL_VALIDATION_REGEX;